<template>
  <div class="card editable-card">
      <div style="display: flex;">
        <div class="links-body">
          <div class="statBlock">
            <div class="card-header" v-if="$slots.header">
              <slot name="header"></slot>
            </div>
            <div class="card-body">
              <div class="inputs row">
              <!--The message below should be a variable we load in-->
               <p style="width: 100%; text-align: center;">Are you sure you want to delete this company? This can't be undone.</p>
              </div>
              <div class="actionbuttons">
                
                <button @click="cancel" :disabled="isDeleting" class="todo-form-cancel-button btn-outline-secondary">Cancel</button>
                <button @click="ok" :disabled="isDeleting" class="todo-form-submit-button btn btn-primary">
                  Yes
                  <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="isDeleting"></i> -->
                  <b-spinner v-if="isDeleting" style="float: right;" small label="Loading..."></b-spinner>
                </button>
              </div>
            </div>
            <!--<a href="#" class="edit-button">Edit</a>-->
            <div class="card-footer" v-if="$slots.footer">
              <slot name="footer"></slot>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>
<script>
  import Card from './Card.vue'
  import {vals} from '../../util'
  import { Dialog, Select, Option } from 'element-ui'

  export default {
    name: 'confirm-card',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      [Dialog.name]: Dialog,
      Card
    },
    props: {
      context: {
        type: Object,
        default () {return {}}
      }
    },
    data () {
      return {
        isDeleting: false,
        confirm: {},
        vals : vals
      }
    },
    methods: {
      cancel () {
        this.$emit('confirm-card-close', this.context, {confirm: false})
      },
      ok () {
        this.isDeleting = true;
        setTimeout(()=>{
          this.$emit('confirm-card-close', this.context, {confirm: true})
        },10)
        
      }
    }
  }
</script>
<style>
.editable-card {
  height: calc(100% - 30px);
}

.links-body {
    width: 100% !important;
}

.edit-company-card-dialog .select-primary {
  margin-right: 10px;
}

.select-box {
  margin-bottom: 10px;
}

.edit-logo-box {
  margin-bottom: 10px;
  margin-left: 10px;
}

.edit-logo-box div {
  margin-bottom: 5px;
}

.select-box div {
  margin-bottom: 5px;
}

.url-form-field {
  border: 1px solid #707070;
  border-radius: 3px;
  padding: 8px;
  height: 40px;
}

</style>